import React from 'react';
import { DropzoneArea } from 'material-ui-dropzone';

export interface IFileWellProps {
  handleDrop: any;
  acceptedFiles?: any;
  filesLimit?: number;
  required?: boolean;
  error?: boolean;
  name?: string;
  helperText?: string;
  className?: string;
}

const FileWell = ({
  handleDrop,
  acceptedFiles,
  filesLimit,
  required,
  name,
  helperText,
  error,
  className,
}: IFileWellProps) => {
  const handleChange = (files: any) => {
    handleDrop(files);
  };

  return (
    <>
      <DropzoneArea
        filesLimit={filesLimit}
        acceptedFiles={acceptedFiles}
        onChange={handleChange.bind(this)}
        dropzoneClass={`${className} ${error ? 'Mui-error' : ''}`}
        dropzoneText={helperText || 'Drag and drop a file here or click'}
        data-id="uploadBox"
        showFileNames={true}
        inputProps={{
          required: !!required,
          name: name || 'uploadBox',
        }}
      />
    </>
  );
};

export default FileWell;
